module.exports = __webpack_public_path__ + "img/close-up-beslag.38785351.jpg";